export default __webpack_public_path__ + "static/color-emphasis-levels-text-light-5857387763bb863eba48b93a6fba918c687ee29ce06b48b066a57aa1031bf56b.png";